import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Table } from "react-bootstrap";
import { getActiveUserList } from "../../../services/api_function";
import { Tooltip, IconButton } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";

export const ActiveUser = () => {
  const itemsPerPage = 10;
  const [apiData, setApiData] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copy address");

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Copy address"), 2000);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getActiveUserList(currentPage, itemsPerPage);
        if (result?.status === 200) {
          console.log(result?.data, "this is the result");
          setApiData(result?.data?.data || []);
          setTotalUsers(result?.data?.pagination?.total || 0);
          setTotalPages(result?.data?.pagination?.totalPages || 1);
        }
      } catch (error) {
        console.error("Error fetching active users:", error);
      }
    };
    fetchData();
  }, [currentPage]);

  const handleSearch = (e) => {
    const query = e.target.value.trim().toLowerCase();
    const sanitizedQuery = query.replace(/[\\|^$*+?.(){}[\]]/g, "");
    setSearch(sanitizedQuery);

    if (sanitizedQuery === "") {
      setIsSearching(false);
      setFilteredData([]);
    } else {
      const results = apiData.filter((item) =>
        item.user_address?.toLowerCase().includes(sanitizedQuery),
      );
      setFilteredData(results);
      setIsSearching(true);
    }
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const displayData = isSearching ? filteredData : apiData;

  return (
    <Fragment>
      <Row>
        <div className="d-flex justify-content-end mb-3">
          <div className="input-group" style={{ maxWidth: "300px" }}>
            <input
              type="search"
              className="form-control"
              placeholder="Search wallet address..."
              onChange={handleSearch}
              value={search}
            />
          </div>
        </div>

        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title className="text-white">Active Users</Card.Title>
            </Card.Header>
            <Card.Body>
              <Table
                responsive
                className="table table-bordered table-striped table-hover"
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>User ID</th>
                    <th>User Wallet</th>
                    {/* <th>Referral ID</th> */}
                    <th>Referral Wallet</th>
                    <th>Total Team</th>
                    <th>Date & Time</th>
                    <th>Dashboard</th>
                  </tr>
                </thead>
                <tbody>
                  {!displayData.length ? (
                    <tr>
                      <td colSpan="8" className="text-center text-muted">
                        No users found.
                      </td>
                    </tr>
                  ) : (
                    displayData.map((data, index) => (
                      <tr key={data._id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{data?.userId}</td>
                        <td>
                          {data?.user?.slice(0, 5)}...{data?.user?.slice(-4)}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton
                              onClick={() => handleCopy(data?.user)}
                              size="small"
                              style={{ marginLeft: 4 }}
                            >
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td>
                        {/* <td>{data?.randomRefferarAddress}</td> */}
                        <td>
                          {data?.referrer?.slice(0, 5)}...
                          {data?.referrer?.slice(-4)}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton
                              onClick={() => handleCopy(data?.referrer)}
                              size="small"
                              style={{ marginLeft: 4 }}
                            >
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td>
                        <td>{data?.teamCount}</td>
                        <td>
                          {new Date(data.timestamp * 1000).toLocaleString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            },
                          )}
                        </td>
                        <td>
                          <a
                            href={`https://dforce.biz/dashboard/?userAddress=${data?.user}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-inline-flex align-items-center gap-2 fw-semibold text-decoration-none text-dark"
                            title="Open User Dashboard"
                          >
                            {/* User / Wallet Icon */}
                            <i className="bi bi-wallet2 text-primary"></i>

                            {/* Short Address */}
                            <span>
                              {data?.user?.slice(0, 5)}...
                              {data?.user?.slice(-4)}
                            </span>

                            {/* External Link Icon */}
                            <i
                              className="bi bi-box-arrow-up-right text-muted"
                              style={{ fontSize: 12 }}
                            ></i>
                          </a>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>

              <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                <span>
                  Page <strong>{currentPage}</strong> of{" "}
                  <strong>{totalPages}</strong>
                </span>

                <button
                  className="btn btn-outline-success"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>

                <span>Total Users: {totalUsers}</span>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ActiveUser;
